export function urlHasKey(key, URLObject) {
  const url = URLObject || window.location;
  const searchString = url.search;
  const searchParams = new URLSearchParams(searchString);

  return searchParams.has(key);
}
